// extracted by mini-css-extract-plugin
export var grayCircle = "_fs-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_fs-1";
export var selectedCircle = "_fs-2";
export var shippingOptionImage = "_fs-3";
export var shippingOptionWidgetPreview = "_fs-4";